<div class="tw-px-6 tw-pt-10 tw-pb-8 tw-relative">
  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-w-8 tw-h-8 tw-top-4 tw-right-4 tw-bg-[#F3F3F3] tw-rounded-full" (click)="closeBottomSheet()">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-[13px] tw-h-[13px] tw-text-400 tw-leading-4 tw-text-gray-500 tw-font-bold">&#10005;</div>      
  </div>

  <div>
    <p class="tw-capitalize tw-mb-3 tw-font-lexend tw-font-bold tw-text-gray-800 tw-text-400" i18n="@@priceDetail">Price Detail</p>
    @for(product of data?.regimenDetails?.products; track product.id) {
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500">{{product.title}}</p>
        <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-gray-500">₹{{product.mrp}}</p>
      </div>
    }
    <div class="tw-my-3 tw-h-[1px] tw-w-full tw-bg-[repeating-linear-gradient(to_right,#CFCFCF_0,#CFCFCF_5px,transparent_5px,transparent_11px)]"></div>
    <div class="tw-flex tw-items-center tw-justify-between tw-font-lexend tw-font-bold tw-text-gray-800">
      <p class="tw-text-300 tw-leading-[28px]" i18n="@@total">Total</p>
      <p class="tw-text-200 tw-leading-[18px]">₹{{productsTotalMrp}}</p>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-font-lexend tw-font-bold tw-text-gray-800">
      <p class="tw-text-300 tw-leading-[28px] tw-font-normal" i18n="@@discount">Discount</p>
      <p class="tw-text-200 tw-leading-[18px] tw-font-medium tw-text-orange-500">- ₹{{originalDiscount}}</p>
    </div>
    @if (cashUsed > 0) {
      <div class="tw-flex tw-items-center tw-justify-between tw-font-lexend tw-font-bold tw-text-gray-800">
        <p class="tw-text-300 tw-leading-[28px] tw-font-normal tw-flex tw-items-center tw-gap-1">
          <span i18n="@@cureskinCash">Cureskin Cash</span>
          <img class="tw-w-4 tw-h-4" src="/assets/images/cureskin-cash-icon.png" />
        </p>
        <p class="tw-text-200 tw-leading-[18px] tw-font-medium tw-text-orange-500">- ₹{{cashUsed}}</p>
      </div>
    }
    <div class="tw-my-3 tw-h-[1px] tw-w-full tw-bg-[repeating-linear-gradient(to_right,#CFCFCF_0,#CFCFCF_5px,transparent_5px,transparent_11px)]"></div>
    <div class="tw-flex tw-items-center tw-justify-between tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800">
      <p class="tw-capitalize" i18n="@@toPay">To pay</p>
      <p>₹{{data?.regimenDetails?.totalSP}}</p>
    </div>
  </div>

</div> 
